<template>
    <div class="flex flex-col justify-center items-center mb-4 w-full">
        <h1 class="font-bold text-6xl text-stroke-3 py-2 bastarda text-center">Fighting Pirates !</h1>
        <p class="text-center italic text-2xl text-stone-500 pixelify-sans">
        Tous les coups sont permis !
        </p>
    </div>
</template>

<script lang="js" setup>
</script>